/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { GET_WP_APPLICATION } from '../../api/graphql';
import { useApplication } from '../provider';
import { FormatAppService } from './formatApp.plugin';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IGetWPApplicationMethods extends IPluginMethodMap {
  getWPApplicationDetail(args: any): Promise<any>;
}

export class GetWPApplicationService implements IAgentPlugin {
  readonly methods: IGetWPApplicationMethods;

  constructor() {
    this.methods = {
      getWPApplicationDetail: this.getWPApplicationDetail.bind(this),
    };
  }

  private async getWPApplicationDetail(args: any) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const { credentialNo } = useApplication();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_WP_APPLICATION, {
          credentialNo: credentialNo,
        });
        if (res?.data) {
          console.log(`table data`, res);
          let tempData = res?.data?.getWorkPermit;
          if (tempData['employer']) {
            tempData['employerInfo'] = tempData['employer'];
          }
          if (tempData['issuedTo']) {
            tempData['applicantInfo'] = tempData['issuedTo'];
          }
          console.log("22223", new FormatAppService().formatApp({...tempData,issued:true}))
          return new FormatAppService().formatApp({...tempData,issued:true});
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }
}
